import { render, staticRenderFns } from "./custom-search.vue?vue&type=template&id=be90a638&scoped=true&"
import script from "./custom-search.vue?vue&type=script&lang=js&"
export * from "./custom-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be90a638",
  null
  
)

export default component.exports